/**
 * 创建时间：2023/7/27 16:19
 * 创建人：toyehuang
 * 文件描述：用于储存页面中多处使用一些固定枚举值,便于后期统一维护
 * 注意：文件内容中常亮请使用全大写,下划线串联单词的形式（例： CONSTANT_EXAMPLE: '常量'）
 */
/**
 * SELECT Options 对应的 item 的字段
 * @type {{CODE: 'value值', LABEL: '显示名称'}}
 */
export const SELECT_OPTION_CONFIG = {
  LABEL: "label",
  CODE: "code",
  CHILDREN: "children",
  VISIBLE: "visible"
};
// 信息发布类菜单 顶层导航栏 对应的code  方便向下查找
export const TOP_NAV_MENU_CODE = {
  // 平台信息
  PLATFORM_INFO: "ptxx",
  // 政策法规
  LAWS_POLICY: "zcfg",
  // 服务指南
  SERVICE_GUIDE: "fwzn",
  // 关于我们
  ABOUT_US: "gywm"

}
// 广告位 对应的 code
export const AD_CODE = {
  // banner 图
  BANNER: "banner",
  // 首页 一号广告位
  AD_A: "ad_a",
  // 首页 二号广告位
  AD_B: "ad_b",
  // 首页 平台动态/通知公告 模块边上的 图片新闻
  AD_NEWS: "ad_news"
}

// 头部导航的所有code 配置时 记得添加
export const NAV_MENU_CODE = {
  // 首页
  HOME: "home",
  // 项目信息/招标公告
  PURCHASE: "xmxx",
  // 平台信息
  PLATFORM_INFO: "ptxx",
  // 政策法规
  LAWS_POLICY: "zcfg",
  // 服务指南
  SERVICE_GUIDE: "fwzn",
  // 平台动态
  PLATFORM_UPDATES: "ptdt",
  // 通知公告
  NOTICES: "tzgg",
  // 常见问题
  FAQ: "cjwt",
  // 关于我们
  ABOUT_US: "gywm"
}

/**
 * 适用于头部搜索框内,切换查询条件的下拉框
 * @type {{PROJECT_CODE: {CODE: string, LABEL: string}, PROJECT_NAME: {CODE: string, LABEL: string}}}
 */
export const SEARCH_INPUT_OPTIONS_TYPES = {
  BIDDING_NOTICE: {
    [SELECT_OPTION_CONFIG.LABEL]: "项目信息",
    [SELECT_OPTION_CONFIG.CODE]: NAV_MENU_CODE.PURCHASE
  },
  PLATFORM_INFO: {
    [SELECT_OPTION_CONFIG.LABEL]: "平台信息",
    [SELECT_OPTION_CONFIG.CODE]: NAV_MENU_CODE.PLATFORM_INFO
  },
  LAWS_POLICY: {
    [SELECT_OPTION_CONFIG.LABEL]: "政策法规",
    [SELECT_OPTION_CONFIG.CODE]: NAV_MENU_CODE.LAWS_POLICY
  },
  SERVICE_GUIDE: {
    [SELECT_OPTION_CONFIG.LABEL]: "服务指南",
    [SELECT_OPTION_CONFIG.CODE]: NAV_MENU_CODE.SERVICE_GUIDE
  }
};

// 公告类型 枚举值
export const NOTICE_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: ""
  },
  GKZB: {
    [SELECT_OPTION_CONFIG.LABEL]: "招标公告",
    [SELECT_OPTION_CONFIG.CODE]: "gkzb"
  },
  JZXTP: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞争性谈判",
    [SELECT_OPTION_CONFIG.CODE]: "jzxtp"
  },
  JZXCS: {
    [SELECT_OPTION_CONFIG.LABEL]: "竞争性磋商",
    [SELECT_OPTION_CONFIG.CODE]: "jzxcs"
  },
  XJCG: {
    [SELECT_OPTION_CONFIG.LABEL]: "询价采购",
    [SELECT_OPTION_CONFIG.CODE]: "xjcg"
  },
  DYLY: {
    [SELECT_OPTION_CONFIG.LABEL]: "单一来源采购",
    [SELECT_OPTION_CONFIG.CODE]: "dyly"
  }
};

// 项目类型枚举值
export const PROJECT_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    EN: "ALL"
  },
  GC: {
    [SELECT_OPTION_CONFIG.LABEL]: "工程类",
    [SELECT_OPTION_CONFIG.CODE]: "GC",
    EN: "ENGINEERING"
  },
  HW: {
    [SELECT_OPTION_CONFIG.LABEL]: "货物类",
    [SELECT_OPTION_CONFIG.CODE]: "HW",
    EN: "GOODS"
  },
  FW: {
    [SELECT_OPTION_CONFIG.LABEL]: "服务类",
    [SELECT_OPTION_CONFIG.CODE]: "FW",
    EN: "SERVICE"
  },
  QT: {
    [SELECT_OPTION_CONFIG.LABEL]: "其他",
    [SELECT_OPTION_CONFIG.CODE]: "QT",
    EN: "OTHER"
  }
};

// 项目状态枚举值
export const PROJECT_STATUS_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  WKS: {
    [SELECT_OPTION_CONFIG.LABEL]: "未开始",
    [SELECT_OPTION_CONFIG.CODE]: "0",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  BMZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "报名中",
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  BMJZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "报名截止",
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  GSZ: {
    [SELECT_OPTION_CONFIG.LABEL]: "公示中",
    [SELECT_OPTION_CONFIG.CODE]: "3",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  GSJS: {
    [SELECT_OPTION_CONFIG.LABEL]: "公示结束",
    [SELECT_OPTION_CONFIG.CODE]: "4",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  YZB: {
    [SELECT_OPTION_CONFIG.LABEL]: "已中标",
    [SELECT_OPTION_CONFIG.CODE]: "5",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  YFB: {
    [SELECT_OPTION_CONFIG.LABEL]: "已废标",
    [SELECT_OPTION_CONFIG.CODE]: "6",
    [SELECT_OPTION_CONFIG.VISIBLE]: true
  },
  YCXZB: {
    [SELECT_OPTION_CONFIG.LABEL]: "已重新招标",
    [SELECT_OPTION_CONFIG.CODE]: "7",
    [SELECT_OPTION_CONFIG.VISIBLE]: false
  },
  ZBGS: {
    [SELECT_OPTION_CONFIG.LABEL]: "中标公示",
    [SELECT_OPTION_CONFIG.CODE]: "8",
    [SELECT_OPTION_CONFIG.VISIBLE]: false
  },
  XJGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "详见公告",
    [SELECT_OPTION_CONFIG.CODE]: "9",
    [SELECT_OPTION_CONFIG.VISIBLE]: false
  },
  XJGS: {
    [SELECT_OPTION_CONFIG.LABEL]: "详见公示",
    [SELECT_OPTION_CONFIG.CODE]: "10",
    [SELECT_OPTION_CONFIG.VISIBLE]: false
  }
};

// 状态对应按钮文字
export const PROJECT_STATUS_BUTTON_TEXT = {
  "0": "未开始",
  "1": "报名",
  "2": "报名截止",
  "3": "我要参加",
  "4": "详见公告",
  "5": "已中标",
  "6": "已废标",
  "7": "重新招标",
  "8": "已中标",
  "9": "详见公告",
  "10": "详见公示",
  "default": "详见公告"
};

// 信息类型
export const INFO_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.LABEL]: "全部",
    [SELECT_OPTION_CONFIG.CODE]: ""
  },
  ZBGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "采购公告",
    [SELECT_OPTION_CONFIG.CODE]: "1"
  },
  BGGG: {
    [SELECT_OPTION_CONFIG.LABEL]: "澄清/变更公告",
    [SELECT_OPTION_CONFIG.CODE]: "2"
  },
  ZBHXRGS: {
    [SELECT_OPTION_CONFIG.LABEL]: "候选人公示",
    [SELECT_OPTION_CONFIG.CODE]: "3"
  },
  ZBJG: {
    [SELECT_OPTION_CONFIG.LABEL]: "结果公告",
    [SELECT_OPTION_CONFIG.CODE]: "4"
  }
};

// 组织形式
export const ORGANIZATION_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.LABEL]: "全部"
  },
  WTCG: {
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.LABEL]: "机构"
  },
  QYZZ: {
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.LABEL]: "自主"
  }
};

// 平台信息
export const PLATFORM_INFO_TYPE_OPTIONS = {
  PTDT: {
    [SELECT_OPTION_CONFIG.LABEL]: "公告",
    [SELECT_OPTION_CONFIG.CODE]: "ptdt"
  },
  BGGG: {}
}

export const MAP_ACTION = {
  SET: "set",
  DEL: "delete",
  HAS: "has",
  CLEAR: "clear"
};

export const PERMISSION_ROLE = {
  MENU: "MENU",
  SITE: "SITE"
};

// 友情链接 的枚举值
export const LINK_TYPE = {
  // 发布媒体
  FBMT: "fbmt",
  // 采购代理机构
  CGDLJG: "cgdljg",
  // 区直国企
  QZGQ: "qzgq",
  // 国资监管
  GZJG: "gzjg",
  // 合作机构
  HZJG: "hzjg",
  // 友情链接
  FRIENDLY_LINK: "link"
};

/**
 * 注册页面使用的常量
 * @type {{REGISTER_TYPE_CGR: string, SYSTEM_XXFB: string, SYSTEM_QYZC: string, REGISTER_TYPE_GYS: string, SSJT_OTHER_CODE: number}}
 */
export const REGISTER_PAGE_CONSTANT = {
  // 所属集团 选择 其他 对应的 code
  SSJT_OTHER_CODE: -1,
  // 注册身份: 供应商
  REGISTER_TYPE_GYS: "17",
  // 注册身份: 采购人
  REGISTER_TYPE_CGR: "12",
  // 系统服务: 信息发布
  SYSTEM_XXFB: "1",
  // 系统服务: 企业自采
  SYSTEM_QYZC: "2"
};
/**
 * 获取 会员协议 对应的 页面类型
 * @type {{MEMBER_REGISTER: string, ENTERPRISE_ENTER: string}}
 */
export const PROTOCOL_PAGE_TYPE = {
  // 会员注册
  MEMBER_REGISTER: "1",
  // 入驻申请
  ENTERPRISE_ENTER: "2"
};

/**
 * 注册页面, 获取用户协议是, 对应的用户身份
 * @type {{GYS: string, CGR: string}}
 */
export const PROTOCOL_TYPE = {
  // 采购人
  [REGISTER_PAGE_CONSTANT.REGISTER_TYPE_CGR]: "cgr",
  // 供应商
  [REGISTER_PAGE_CONSTANT.REGISTER_TYPE_GYS]: "gys"
};

/**
 * 文件上传通用 url
 * @type {string}
 */
export const UPLOAD_FILE_URI =
  process.env.VUE_APP_BASE_API +
  process.env.VUE_APP_APP_API +
  "/infra/file/upload";

/**
 * 模版文件 code
 * @type {{SQS_FGS: string, SQS: string, SFZ: string}}
 * @desc {{SQS_FGS: 授权书模板(分公司注册版本), SQS: 授权书模板, SFZ: 身份证明}}
 */
export const TEMPLATE_CODE = {
  // 身份证明
  SFZ: "sfz",
  // 授权书模板
  SQS: "sqs",
  // 授权书模板(分公司注册版本)
  SQS_FGS: "sqs_fgs"
};
/**
 * 模版文件 pageType
 * @type {{ORG: string, MEMBER: string}}
 * @desc {{ORG: 入驻申请, MEMBER: 会员注册 }}
 */
export const TEMPLATE_PAGE_TYPE = {
  MEMBER: "member",
  ORG: "org"
};
// 单位类型
export const UNIT_TYPE_OPTIONS = {
  ALL: {
    [SELECT_OPTION_CONFIG.CODE]: "",
    [SELECT_OPTION_CONFIG.LABEL]: "全部"
  },
  CITY: {
    [SELECT_OPTION_CONFIG.CODE]: "1",
    [SELECT_OPTION_CONFIG.LABEL]: "市属企业"
  },
  COUNTY: {
    [SELECT_OPTION_CONFIG.CODE]: "2",
    [SELECT_OPTION_CONFIG.LABEL]: "区县（市）企业"
  }
}

export function getConstantDic(dicObj) {
  // eslint-disable-next-line no-prototype-builtins
  const isVisible = (item) => !item.hasOwnProperty(SELECT_OPTION_CONFIG.VISIBLE) || item[SELECT_OPTION_CONFIG.VISIBLE]
  return Object.values(dicObj).filter(item => isVisible(item))
}
